import React, {useState,useEffect} from 'react'
import { useNavigate} from 'react-router-dom';
import { toast } from 'react-toastify';
import { post } from '../../Services/Api';
import LeftArrow from './../../Assets/images/left-arrow.svg';
import Opennotification from '../../Components/Opennotification';

const ForgotPassword = () => {
  const [username,setUsername] = useState("");
  const [password,setPassword] = useState("");
  const [enteremail,setenteremail] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    // Clear specific localStorage items for Forgot Password page
    localStorage.removeItem("emailEntered");
  }, []);


  const handleEmailChange = async (e)=>{
    setenteremail(e.target.value)
  }

  const resetPassword = async (e)=>{
    e.preventDefault();
    try{
      const response = await post(`forgotpassword?email=${enteremail}`)

      if(response && response.status === 200)
      {
        Opennotification("success","Email Sent", "OTP has been sent to your email.")
        // navigate('/otp',{state:{email:enteremail}})
        
      localStorage.setItem("emailEntered", "true");
        // navigate('/reset-password',{state:{email:enteremail}})

        // setTimeout(() => {
        //   navigate("/reset-password", { state: { email: enteremail } });
        // }, 100);

        setTimeout(() => {
          console.log("LocalStorage value:", localStorage.getItem("emailEntered")); // Debugging
          navigate("/reset-password", { state: { email: enteremail } });
        }, 100);

        // navigate('/otp',{state:{email:enteremail}})
        
        
      }else{
        Opennotification(
          "error",
          "Failed",
          response.message || "Failed to send OTP. Please try again."
        );
        
      }
    }
    catch(e){
      Opennotification(
        "error",
        "Error",
        "An error occurred while processing your request. Please try again."

      )
    }
  }
    

  


  return (
    <div className="position-relative login-bg">
      {/* <div className="login-bg"></div> */}
      <div className="container vh-100">
        <div className="row align-items-center h-100">
          <div className="col-lg-6">
              <div className="bg-white login-main-box">
                  <h4 className="heading">SHARED PARKING</h4>

                  <h3 className="title mb-2">
                  Forgot Password?
                  </h3>
                  <p className="mb-5" style={{color: '#797979', fontSize: '16px'}}>
                  No Worries, we’ll send you reset instructions 
                  </p>
                  <form>
                  <div className="form-group mb-5">
                    <label htmlFor="">Enter your Email</label>
                    <input 
                    type="text"
                    className="form-control"
                    value={enteremail}
                    onChange={handleEmailChange}
                    />
                  </div>
              
                  <button 
                  className="btn btn-primary w-100 my-3"
                  onClick={resetPassword}
                  >
                    Reset Password
                  </button>
                  </form>
                  <p className="text-center sign-up-below">
                     <a href="/">
                       <img src={LeftArrow} alt="" className="me-2" style={{width: '15px'}} />
                       Back to Login </a> 
                  </p>
              </div>
          </div>
          <div className="col-lg-6">

          </div>
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword;